// @ts-strict-ignore
import {
  Component, OnInit, OnDestroy, AfterViewInit, ViewContainerRef, ViewChild,
  ChangeDetectorRef, Output, EventEmitter
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SohoDataGridComponent } from 'ids-enterprise-ng';
import { LMAuditLogService } from '@services/lm-audit-log.service';
import { LMBaseComponent, SaveRequired } from '../base';
import {
  LMBusyIndicatorService,
  LMComponentInfoService,
  LMModalOpenService,
  LMModalWrapperService
} from '@services/index';
import { LMToolbarComponent } from '@toolbar/lm-toolbar.component';
import { LMAuditLogCompareDialogComponent } from './lm-audit-log-compare-dialog.component';
import { LMFormatUtilService } from '@services/utils/lm-format-util.service';
import { environment } from '@environments/environment';
import { Subscription, SubscriptionLike } from 'rxjs';
import { LMContextService } from '@services/lm-context.service';
import { LMHtmlPageUtilService } from '@html/lm-html-page-util.service';
import { LMGlobalPersonalizationService } from '@states/services/lm-global-personalization.service';
import { LMFormManualRepService } from '@form/lm-form-manual-rep.service';
import {LMDialogButtonKey, LMTransformOptions, LMUniqueIdService} from '@utils/index';
import { LMFieldUtilService } from '@services/utils/lm-field-util.service';
import { LMAppComponentService } from '@utils/lm-app-component.service';
import { LMBannerHeaderComponentRef } from '../banner/lm-banner-header-component-ref.service';

@Component({
  selector: 'lm-audit-log',
  standalone: false,
  templateUrl: 'lm-audit-log.component.html',
  styleUrls: [ 'lm-audit-log.component.scss' ],
  providers: [
    LMHtmlPageUtilService,
    LMFormManualRepService
  ]
})
export class LMAuditLogComponent extends LMBaseComponent implements OnInit, OnDestroy, AfterViewInit, SaveRequired {

  @ViewChild(SohoDataGridComponent) dataGridComponent: SohoDataGridComponent;
  @ViewChild(LMToolbarComponent) toolBarComponent: LMToolbarComponent;

  @Output() titleChanged = new EventEmitter<string>();

  public auditData: LMAuditData;
  private auditRows: LMAuditDataRow[];
  private auditTitle: string;
  private auditFetch: Subscription;
  public dataset: LMAuditDataRow[];
  private routeParams: SubscriptionLike;
  public isProduction = environment.production;
  public selectedRows: SohoDataGridSelectedRow[] = [];
  private actionType: LMToolbarActionType = 'standard';
  private actionName: string;
  public toolbarButtons: LMToolbarButton[] = [
    {
      actionReference: {
        id: 'compare_btn',
        type: this.actionType,
        label: 'Compare',
        name: 'Compare'
      },
      icon: 'queries',
      data: 'Compare',
      id: 'compare_btn',
      state: { disabled: true, visible: true },
      automationId: 'audit-log-compare'
    },
    {
      actionReference: {
        id: 'sort_btn',
        type: this.actionType,
        label: 'SortUp',
        name: 'Sort'
      },
      icon: 'sort-up',
      data: 'Sort',
      id: 'sort_btn',
      state: { disabled: false, visible: true },
      automationId: 'audit-log-sort'
    }
  ];


  private isFullAuditLog: boolean;

  constructor(
    private   route: ActivatedRoute,
    private   router: Router,
    private   lmAuditLogService: LMAuditLogService,
    private   lmBannerHeaderComponentRef: LMBannerHeaderComponentRef,
    protected lmBusyIndicatorService: LMBusyIndicatorService,
    private   lmFormatUtilService: LMFormatUtilService,
    private   lmContextService: LMContextService,
    private   lmHtmlPageUtilService: LMHtmlPageUtilService,
    private   lmGlobalPersonalizationService: LMGlobalPersonalizationService,
    private   changeDetectorRef: ChangeDetectorRef,
    protected lmComponentInfoService: LMComponentInfoService,
    protected lmUniqueIdService: LMUniqueIdService,
    private   lmFieldUtilService: LMFieldUtilService,
    protected lmAppComponentService: LMAppComponentService,
    private   lmBannerHeaderCompRef: LMBannerHeaderComponentRef,
    protected lmModalWrapperService: LMModalWrapperService,
    protected lmModalOpenService: LMModalOpenService
  ) {
    super(lmBusyIndicatorService, lmComponentInfoService, lmUniqueIdService, lmAppComponentService, lmModalWrapperService, lmModalOpenService);
  }

  /**
   * Start: Inherited methods from  LMBaseComponent
   */
  getComponentInfo(): LMComponentInfo {
    return undefined;
  }

  public getUserWebRequestId(): string {
    return 'AuditLog' + '-' +this.getBaseCompId();
  }

  getComponentPlaceHolder(): ViewContainerRef {
    return undefined;
  }

  /**
   * End: Inherited methods from  LMBaseComponent
   */

  ngOnInit() {
    this.showBusyIndicator();
    this.toolbarButtons[0].actionReference.label = Soho.Locale.translate('Compare');
    this.toolbarButtons[1].actionReference.label = Soho.Locale.translate('SortUp');

    this.routeParams = this.route.params
      .subscribe(params => {
        const resource: string[] = params.resourceId.split('.');
        this.actionName = resource[1] === 'viewAudit' ? Soho.Locale.translate('AuditLog') : Soho.Locale.translate('FullAuditLog');
        this.isFullAuditLog = this.actionName !== 'viewAudit';
      });

    const bannerPersonalization = this.lmGlobalPersonalizationService.getGlobalPersonalization();
    const appDisplay = bannerPersonalization.appDisplay;
    // let unsupportedPattern = this.doesSpecContainUnsupported4_0Patterns(this.pageSpec);
    this.setLegacyVariables(false, appDisplay, this.lmContextService, this.lmHtmlPageUtilService);

    if (this.url3_5 && this.legacyWebUI) {
      this.changeDetectorRef.detectChanges();
    } else {
      this.auditFetch = this.lmAuditLogService.getAuditLogData(this.router.url)
        .subscribe((auditData: LMAuditData) => {
          this.auditData = auditData;

          this.auditTitle = this.lmFormatUtilService.formatMessage(this.actionName, this.auditData.resourceString);

          if (this.lmBannerHeaderComponentRef.instance) {
            this.lmBannerHeaderComponentRef.instance.toolbarSectionTitle = this.auditTitle;
            if (this.auditData.isArchiveData) {
              this.lmBannerHeaderCompRef.instance.mustacheText = Soho.Locale.translate('DisplayingArchiveData');
            }
          }
          if (!this.lmContextService.isBannerInRoute() && this.lmContextService.showBreadcrumbs()) {
            this.lmBannerHeaderCompRef.updateBreadcrumbs({
              id: undefined,
              category: this.lmBannerHeaderCompRef.getCurrentCategory(),
              busClass: '',
              specName: 'AuditLog',
              type: 'SYSTEM',
              title: this.auditTitle,
              routeUrl: this.router.url
            });
          }

          const columns: SohoDataGridColumn[] = [];

          const checkBoxColumn: SohoDataGridColumn = {
            id: 'selectionCheckbox',
            sortable: false,
            resizable: false,
            formatter: Soho.Formatters.SelectionCheckbox,
            align: 'center'
          };

          const dataColumns: SohoDataGridColumn[] = this.auditData.fieldNames.map((fieldName: string, index: number) => ({
            id: fieldName,
            name: this.auditData.labels[index] ? this.auditData.labels[index] : this.lmFieldUtilService.decodeFieldName(fieldName),
            field: fieldName + index,
            sortable: false,
            singleline: true,
            formatter: 'Editor'
          }));

          columns.push(checkBoxColumn);
          dataColumns.forEach((dataColumn: SohoDataGridColumn) => columns.push(dataColumn));

          this.dataset = this.auditData.rows.map((row: LMAuditRow[], index: number) => {
            const data = {} as LMAuditDataRow;
            for (let i = 0; i < row.length; i++) {
              const key = dataColumns[i].field;
              const currentRow = row[i];
              const classes = this.addAdditionalStyle(currentRow);
              const transformOptions: LMTransformOptions = {
                precision: currentRow.precision,
                decSize: currentRow.precision
              };
              if (currentRow.type === 'TIME')
                transformOptions.displayZero = true;
              const displayValue = this.lmFormatUtilService.toDisplayValue(currentRow.value, currentRow.type, transformOptions);

              data[key] = classes ? `<span class='${classes}'>${displayValue}</span>` : displayValue;
            }

            data.index = index;
            return data;
          });

          const gridOptions: SohoDataGridOptions = <SohoDataGridOptions>{
            columns,
            selectable: 'multiple',
            dataset: this.dataset,
            paging: false
          };

          gridOptions['headerBackgroundColor'] = 'light';

          this.dataGridComponent.gridOptions = gridOptions;
          this.changeDetectorRef.detectChanges();

          this.auditRows = this.auditData.rows.map((row: LMAuditRow[]) => {
            const data = {} as LMAuditDataRow;
            for (let i = 0; i < row.length; i++) {
              const key = dataColumns[ i ].field;
              const currentRow = row[ i ];
              const transformOptions: LMTransformOptions = {
                precision: currentRow.precision,
                decSize: currentRow.precision
              };
              if (currentRow.type === 'TIME')
                transformOptions.displayZero = true;
              const displayValue = this.lmFormatUtilService.toDisplayValue(currentRow.value, currentRow.type, transformOptions);

              data[ key ] = displayValue ;
            }
            return data;
          });

          this.hideBusyIndicator();
        });
    }
  }

  ngOnDestroy() {
    if (this.routeParams) {
      this.routeParams.unsubscribe();
    }

    if (!this.legacyWebUI && !this.url3_5) {
      if (this.auditFetch) {
        this.auditFetch.unsubscribe();
      }
    }
    if (this.lmBannerHeaderCompRef?.instance) {
      this.lmBannerHeaderCompRef.instance.mustacheText = null;
    }
  }

  ngAfterViewInit() {
    if (this.lmBannerHeaderComponentRef.instance) {
      this.lmBannerHeaderComponentRef.instance.fullPageScroll = false;
    }

    if (this.lmBannerHeaderComponentRef.instance && this.lmBannerHeaderComponentRef.instance.is3_5 !== undefined) {
      this.lmBannerHeaderComponentRef.instance.is3_5 = (this.url3_5 && this.url3_5.length > 0) ? true : false;
    }

    if (this.lmContextService.isBannerInRoute() && !this.lmContextService.isApplicationMenuV3()) {
      this.connectAppMenuButtonTrigger();
    }
  }

  public onAppMenuTriggerEvent(event) {
    this.lmAppComponentService?.getAppComponent()?.handleV3NavComponent();
  }

  private decodeFieldLabel(label: string): string {
    label = label.replace(new RegExp('_op_', 'g'), '(');
    label = label.replace(new RegExp('_cp_', 'g'), ')');

    label = label.replace(new RegExp('_ob_', 'g'), '{');
    label = label.replace(new RegExp('_co_', 'g'), '}');

    label = label.replace(new RegExp('_ohb_', 'g'), '[');
    label = label.replace(new RegExp('_chb_', 'g'), ']');

    label = label.replace(new RegExp('_lab_', 'g'), '<');
    label = label.replace(new RegExp('_rab_', 'g'), '>');

    label = label.replace(new RegExp('_add_', 'g'), '+');
    label = label.replace(new RegExp('_div_', 'g'), '/');
    label = label.replace(new RegExp('_hat_', 'g'), '^');
    label = label.replace(new RegExp('_pct_', 'g'), '%');
    label = label.replace(new RegExp('_spc_', 'g'), ' ');
    label = label.replace(new RegExp('_col_', 'g'), ':');
    label = label.replace(new RegExp('_prd_', 'g'), '.');
    label = label.replace(new RegExp('_apo_', 'g'), '\'');
    label = label.replace(new RegExp('_sc_', 'g'), '');
    label = label.replace(new RegExp('_quot_', 'g'), '"');

    return label;
  }

  showBusyIndicator() {
    this.lmBusyIndicatorService.showBusyIndicator();
  }

  hideBusyIndicator() {
    this.lmBusyIndicatorService.hideBusyIndicator();
  }

  checkSaveRequired(fromUnifiedMenu?: boolean) {
    return false;
  }

  public allowPageNavigation(): Promise<boolean> {
    return Promise.resolve(true);
  }

  saveComponentState(includeSubComponents?: boolean) {
  }

  displayUnsavedChanges() {
    return Promise.resolve(false);
  }

  modalOpen() {
    return false;
  }

  modalNavigationBlocked(fromUnifiedMenu?: boolean) {
    return false;
  }

  displayNavigationConfirmation(): Promise<boolean> {
    return Promise.resolve(false);
  }

  onRowSelected(event: SohoDataGridSelectedEvent) {
    this.selectedRows = event.rows;
    const compareButton = this.toolbarButtons[0];

    if (compareButton.state.disabled !== (this.selectedRows.length !== 2)) {
      compareButton.state.disabled = !compareButton.state.disabled;
      this.toolBarComponent.forceUpdate();
    }
  }

  onToolbarButtonEvent(toolbarButtonEvent: LMToolbarButtonEvent) {
    if (toolbarButtonEvent.actionReference) {
      if (toolbarButtonEvent.actionReference.name === 'Compare') {
        this.showCompareLogDialog();
      } else if (toolbarButtonEvent.actionReference.name === 'Sort') {
        this.sortAuditLog();
      }
    }
  }

  private showCompareLogDialog() {

    // Create the row data
    const compareDataset = this.createCompareDialogData();
    const dialogId = 'CompareLog';

    // Create modal button
    const buttons = [
      {
        id: this.lmUniqueIdService.uniqueId([ dialogId, LMDialogButtonKey.CLOSE ]),
        text: Soho.Locale.translate(LMDialogButtonKey.CLOSE),
        click: (e, modal) => {
          this.dialog.close(true);
        },
        isDefault: true,
      }
    ];

    const attributes: SohoAttributesArray = [ {
      name: 'data-automation-id',
      value: `lm-audit-compare-modal`
    } ];

    const options: SohoModalOptions = {
      fullsize: 'responsive',
      attributes
    };

    // Show the dialog button
    this.dialog = this.lmModalWrapperService
      .modal(LMAuditLogCompareDialogComponent, options)
      .title(Soho.Locale.translate(dialogId))
      .buttons(buttons)
      .apply((dialogComponent) => {
        dialogComponent.dataset = compareDataset;
      })
      .open();
  }

  private createCompareDialogData(): LMAuditCompareChangedValues[] {
    const rows = [];
    const row1Index = this.selectedRows[0].data.index;
    const row2Index = this.selectedRows[1].data.index;
    const newerRow = row1Index < row2Index ? this.auditRows[row1Index] : this.auditRows[row2Index];
    const olderRow = row1Index < row2Index ? this.auditRows[row2Index] : this.auditRows[row1Index];

    this.auditData.fieldNames.forEach((fieldName: string, index: number) => {
      const data = {} as LMAuditCompareChangedValues;
      const fieldNameWithIndex = fieldName + index;
      const newerRecordValue = newerRow[fieldNameWithIndex];
      const olderRecordValue = olderRow[fieldNameWithIndex];
      if (newerRecordValue !== olderRecordValue) {
        data ['FieldName'] = this.lmFieldUtilService.decodeFieldName(fieldName);
        data ['Label'] = this.auditData.labels[index];
        data ['FromValue'] = olderRecordValue;
        data ['ToValue'] = newerRecordValue;
        rows.push(data);
      }
    });

    return rows;
  }

  private addAdditionalStyle(data: LMAuditRow): string {
    let classes = '';
    if (this.isFullAuditLog
      && data.auditChanged) {
      // If full && Field has auditChange - Render a blue (Color(178, 229, 255)) background
      classes += ' auditCellBlueBG';
    }
    // Set italic font if correction
    if (data.correction) {
      classes += ' auditCellItalic';
    }
    if (data.unapplied) {
      classes += ' auditCellGreen';
    }
    if (data.fieldSuperseded && data.viewSuperseded) {
      // font strike through
      classes += ' auditCellStrikeThru';
    } else if (data.viewSuperseded) {
      // if view is superceded - red color and strike through
      classes += ' auditCellRed auditCellStrikeThru';
    }
    return classes;
  }

  private sortAuditLog() {
    this.showBusyIndicator();
    this.dataGridComponent.unSelectAllRows();
    this.dataset = this.dataset.reverse();
    this.dataGridComponent.dataset = this.dataset;
    this.toolbarButtons[1].icon = this.toolbarButtons[1].icon === 'sort-up' ? 'sort-down' : 'sort-up';
    this.toolbarButtons[1].actionReference.label = this.toolbarButtons[1].icon === 'sort-up' ? Soho.Locale.translate('SortUp') : Soho.Locale.translate('SortDown');
    this.hideBusyIndicator();
  }
}
